import { getMethodWithToken } from 'utils/services/apiService';
import url from 'utils/services/urls.json';

// Action Types
export const GET_SYMPTOMS_LIST = 'GET_SYMPTOMS_LIST';
export const GET_SYMPTOMS_LIST_SUCCESS = 'GET_SYMPTOMS_LIST_SUCCESS';
export const GET_SYMPTOMS_LIST_FAILURE = 'GET_SYMPTOMS_LIST_FAILURE';

// Action Creators
export const getSymptoms = () => ({
  type: GET_SYMPTOMS_LIST,
});

export const getSymptomsSuccess = (users) => ({
  type: GET_SYMPTOMS_LIST_SUCCESS,
  payload: users,
});

export const getSymptomsFailure = (error) => ({
  type: GET_SYMPTOMS_LIST_FAILURE,
  payload: error,
});

// Thunk Function
export const getSymptomsList = (external) => {
  return async (dispatch) => {
    dispatch(getSymptoms());
    try {
      const response = await getMethodWithToken(url.symptomsList);
      if (response?.status === 200 || response?.status === 201) {
        dispatch(getSymptomsSuccess(response?.data));
        if (external?.run === true) {
          external?.handleFunction(response?.data);
        }
      } else if (response?.status === 401 || response?.status === 403) {
        if (external?.authorize === true) {
          external?.handleAuthorizeFunction(response?.data);
        }
      } else {
        external?.handleErrorFunction(response?.data);
      }
    } catch (error) {
      dispatch(getSymptomsFailure(error?.message));
    }
  };
};
